import { Box } from "@mui/material";
import TkStrpper from "../../components/atoms/TkStepper";
import { contextText, headList, stepperData } from "./parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkTable from "../../components/atoms/TkTable";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import {
  httpAPI_CON031,
  httpAPI_CON030,
  httpAPI_FAC023,
  httpAPI_FAC024,
} from "./api/request";
import { TkGetCode } from "../../utils/TkGetCode";
import { FacilityKbn, FacilityKind } from "../../assets/data/Constants";
import "./_style.scss";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { IAPI_FAC023_Response } from "../../type/apiType";

/**
 * SCRC050126 部分解除対象施設一覧
 * 部分解除対象施設を処理する画面
 * @return SCRC050126
 */
const SCRC050126: React.FC = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any[]>([]);
  const kikoUserFlg =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractNo = kikoUserFlg
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const context = businessState.job_16;
  const [res, setRes] = useState<IAPI_FAC023_Response>({});
  const [allRegistered, setAllRegistered] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [staffNoInfoList, setStaffNoInfoList] = useState<any>([]);

  const handleInit = async () => {
    // 持回情報.施設番号をクリアする
    setBusinessState({
      ...businessState,
      job_16: {
        ...businessState.job_16,
        facilityNo: null as any,
      },
    });

    // 部分解除対象施設一覧表示API 呼び出し
    if (context?.applyId) {
      try {
        const res = await httpAPI_FAC023({
          applyId: context?.applyId,
          facilityInfoList: context?.facilityInfoList?.map((item) => ({
            facilityNo: item.facilityNo,
          })),
        });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });

          setRes(res);
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
          navigate("/error");
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let bodyList = context?.facilityInfoList?.map((item) => {
      let processComment =
        res.facilityInfoList?.find((i) => i.facilityNo === item.facilityNo)
          ?.processComment ?? "未登録";

      return [
        {
          children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        },
        {
          children: TkGetCode(FacilityKbn, item.facilityKbn),
        },
        {
          children:
            FacilityKind[item.facilityKind as keyof typeof FacilityKind] ??
            item.facilityKind,
        },
        {
          children: processComment,
        },
        {
          children: (
            <Box className="tableBtnGroup">
              <TkButton onClick={() => handleRegist(item.facilityNo)}>
                登録
              </TkButton>
              <TkButton
                onClick={() => {
                  handleDelete(item.facilityNo, processComment);
                }}
              >
                削除
              </TkButton>
            </Box>
          ),
        },
      ];
    });

    setBodyList(bodyList ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessState, res]);

  useEffect(() => {
    const allRegistered = bodyList.every(
      (facility: any) => facility[3].children === "登録済み"
    );
    setAllRegistered(allRegistered);
  }, [bodyList]);

  // 削除 ボタン 押下
  const handleDelete = async (facilityNo: any, processComment: any) => {
    let facilityInfoList = context?.facilityInfoList?.filter(
      (item) => item.facilityNo !== facilityNo
    );

    if (processComment === "登録済み" || processComment === "登録中") {
      // 部分解除対象施設削除API 呼び出し
      try {
        const res = await httpAPI_FAC024({
          applyId: context?.applyId,
          facilityNo,
        });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
          return;
        }
      } catch (error) {
        navigate("/error");
      }
    }

    setBusinessState({
      ...businessState,
      job_16: {
        ...businessState.job_16,
        facilityInfoList,
      },
    });

    if (!facilityInfoList?.length) {
      navigate("/SCRC050125");
    }
  };

  // 登録 ボタン 押下
  const handleRegist = (facilityNo: any) => {
    setBusinessState({
      ...businessState,
      job_16: {
        ...businessState.job_16,
        facilityNo,
      },
    });
    navigate("/SCRC050127", { state: { facilityNo: facilityNo } });
  };

  // 次へ ボタン 押下
  const handleNext = async () => {
    // 日々更新法人職員系の退職年月日削除職員確認API 呼び出し
    try {
      const res = await httpAPI_CON031({
        contractorNo: contractNo,
        businessType: businessState.common?.businessType,
        applyId: context?.applyId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        setStaffNoInfoList(res.staffNoInfoList);

        if (res.staffNoInfoList) {
          setOpenDialog(true);
        } else {
          navigate("/SCRC050028");
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const dialogOk = async () => {
    // 日々更新法人職員系の退職年月日削除API 呼び出し
    try {
      const res = await httpAPI_CON030({
        contractorNo: contractNo,
        staffNoInfoList: staffNoInfoList,
        businessType: businessState.common?.businessType,
        applyId: context?.applyId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC050028");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  return (
    <Box className="SCRC050126" data-testid="SCRC050126test">
      <TkStrpper steps={stepperData} activeStep={1} />

      <TkInfoManual rule="\n">{labelids.labelid.LBLC050126_01}</TkInfoManual>

      {kikoUserFlg && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo}:${businessState.common?.contractorName}`}
        />
      )}

      <TkTable headList={headList} bodyList={bodyList} />

      <Box className="btnGroup">
        <TkBackButton />
        <TkButton onClick={handleNext} disabled={!allRegistered}>
          次へ
        </TkButton>
      </Box>

      <TkMessageDialog
        open={openDialog}
        onOky={dialogOk}
        onCancel={() => setOpenDialog(false)}
        title="確認（退職(予定)年月日・異動情報(配置換え)が削除されます）"
        children={<TkInfoManual rule={"<"}>{contextText}</TkInfoManual>}
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC050126;
